export { default } from './DuvidasFrequentes25Canais';
